<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  // created() {
  //   let timer = setTimeout(() => {

  //     window.location.reload()
  //   }, 1000)
  // }
}
</script>
<style lang="scss">
@import '@/assets/scss/base.scss';

html,
body,
#app {
   font-size: 100px;
  width: 100%;
  overflow-x: hidden;
}

.swiper-slide {
  opacity: 0.4;
  transition: all .6s;
}

.swiper-slide-active {
  opacity: 1;
}

.el-message i {
  font-size: 0.22rem;
}

.el-dialog__header {
  padding: 20px 20px 10px;
  line-height: 12px;
  font-size: 12px;
}

.el-dialog__footer {
  font-size: 12px;
}

.el-dialog {
  border-radius: 10px !important;
}

.el-button--primary {
  background-color: #E02E43 !important;
  border-color: #E02E43 !important;
}
</style>
